import api from "@/lib/api";

// Session-level cache populated by /auth/bootstrap (or /auth/login) so the
// dashboard boots from a single request instead of chaining /accounts and
// /settings/public. Reduces round-trips, which matters most under high latency.
let _accounts = null;
let _settings = null;
let _settingsPromise = null;

export function setBootstrap(d) {
  if (!d) return;
  if (d.accounts) _accounts = d.accounts;
  if (d.settings) { _settings = d.settings; _settingsPromise = Promise.resolve(d.settings); }
}

// One-time consume of the bootstrapped accounts (so manual refreshes still hit the API).
export function takeBootstrapAccounts() {
  const a = _accounts;
  _accounts = null;
  return a;
}

// Cached public settings — fetched at most once per session.
export async function getPublicSettings() {
  if (_settings) return _settings;
  if (!_settingsPromise) {
    _settingsPromise = api.get("/settings/public")
      .then((r) => { _settings = r.data; return _settings; })
      .catch(() => ({}));
  }
  return _settingsPromise;
}

export function clearBootstrap() {
  _accounts = null;
  _settings = null;
  _settingsPromise = null;
}
